export const CREATE_ADMIN_SCHEDULED_VISITS = "CREATE_ADMIN_SCHEDULED_VISITS";   
export const RETRIEVE_ADMIN_SCHEDULED_VISITS = "RETRIEVE_ADMIN_SCHEDULED_VISITS";
export const RETRIEVESINGLE_ADMIN_SCHEDULED_VISITS = "RETRIEVESINGLE_ADMIN_SCHEDULED_VISITS";
export const UPDATE_ADMIN_SCHEDULED_VISITS = "UPDATE_ADMIN_SCHEDULED_VISITS";   
export const DELETE_ADMIN_SCHEDULED_VISITS = "DELETE_ADMIN_SCHEDULED_VISITS";   
